import React from 'react';
import { ATMModal, ATMButton, IATMConfirmProps } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';

type IConfirm = IATMConfirmProps & {
  loading?: boolean;
  confirmText?: string;
};

const Confirm: React.FC<IConfirm> = ({
  loading = false,
  header,
  content,
  confirmText = Lang.LBL_OKAY,
  onConfirm,
  onCancel,
  ...props
}) => (
  <ATMModal
    {...props}
    onClose={onCancel as any}
    header={header}
    content={content ?? 'Are you sure?'}
    actions={
      <div
        style={{
          padding: '1em 1.5em',
          borderTop: '1px solid rgba(34, 36, 38, 0.15)'
        }}
      >
        <ATMButton basic onClick={onCancel as any}>
          {Lang.LBL_CANCEL}
        </ATMButton>
        <ATMButton
          primary
          onClick={onConfirm as any}
          loading={loading}
          disabled={loading}
        >
          {confirmText}
        </ATMButton>
      </div>
    }
  />
);

export default Confirm;
